import React from 'react';
import { MenuWithDropdownsContainer } from './MenuWithDropdowns.styles';
import Dropdown, { DropdownProps } from 'atoms/Input/Dropdown';
import Stack from 'atoms/Layout/Stack/Stack';

interface MenuWithDropdownsProps {
  dropdowns: DropdownProps[];
}

const MenuWithDropdowns = ({ dropdowns }: MenuWithDropdownsProps): JSX.Element => {
  const getBorderRadius = (index: number): DropdownProps['borderRadius'] => {
    if (index === 0) {
      return {
        topLeft: 'radius-md',
        bottomLeft: 'radius-md',
      };
    }

    if (index === dropdowns.length - 1) {
      return {
        topRight: 'radius-md',
        bottomRight: 'radius-md',
      };
    }

    return undefined;
  };

  return (
    <MenuWithDropdownsContainer
      direction='row'
      justify='flex-start'
      align='flex-start'
      borderRadius='radius-md'
    >
      {dropdowns.map((dropdown, index) => (
        <Stack key={dropdown.placeholder}>
          <Dropdown
            className='dropdown-with-action'
            borderRadius={getBorderRadius(index)}
            typographyProps={{
              whiteSpace: 'nowrap',
              type: 'paragraph',
              size: 'sm',
            }}
            {...dropdown}
          />
        </Stack>
      ))}
    </MenuWithDropdownsContainer>
  );
};

export default MenuWithDropdowns;
